import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Leaf, CheckCircle2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw1.length < 6) { setError("Mot de passe trop court (6 caractères minimum)."); return; }
    if (pw1 !== pw2) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw1 });
      setDone(true);
      setTimeout(() => navigate("/login"), 2200);
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail));
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "var(--bg)" }}>
        <div className="card-soft p-8 max-w-md text-center">
          <div className="font-display text-xl mb-2">Lien invalide</div>
          <p className="text-sm text-muted-soft mb-4">Ce lien est incomplet ou expiré.</p>
          <Link to="/forgot-password" className="btn-sage text-sm">Demander un nouveau lien</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-2xl bg-sage flex items-center justify-center">
            <Leaf className="w-5 h-5 text-white" strokeWidth={1.6} />
          </div>
          <div>
            <div className="font-display">Mon Cabinet Bien-être</div>
            <div className="text-xs text-muted-soft">by Capsule Patrimoine</div>
          </div>
        </Link>

        {done ? (
          <div className="card-soft p-7 space-y-3" data-testid="reset-done">
            <CheckCircle2 className="w-12 h-12 text-sage" strokeWidth={1.4} />
            <div className="font-display text-xl">Mot de passe modifié</div>
            <p className="text-sm text-muted-soft">Redirection vers la connexion…</p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl mb-2">Nouveau mot de passe</h1>
            <p className="text-muted-soft mb-8">Choisissez un mot de passe — au moins 6 caractères.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="text-sm font-medium block mb-2">Nouveau mot de passe</label>
                <input data-testid="reset-pw1" type="password" required minLength={6} value={pw1}
                  onChange={(e) => setPw1(e.target.value)} placeholder="••••••••" className="input-soft" />
              </div>
              <div>
                <label className="text-sm font-medium block mb-2">Confirmer le mot de passe</label>
                <input data-testid="reset-pw2" type="password" required minLength={6} value={pw2}
                  onChange={(e) => setPw2(e.target.value)} placeholder="••••••••" className="input-soft" />
              </div>
              {error && (
                <div className="text-sm rounded-xl px-4 py-3" style={{ backgroundColor: "#FBEEE8", color: "#8B4D3D" }} data-testid="reset-error">
                  {error}
                </div>
              )}
              <button type="submit" disabled={loading} className="btn-sage w-full text-base py-3.5" data-testid="reset-submit">
                {loading ? "Mise à jour…" : "Valider mon nouveau mot de passe"}
              </button>
              <Link to="/login" className="text-sm text-muted-soft hover:text-sage inline-flex items-center gap-1">
                <ArrowLeft className="w-4 h-4" /> Retour à la connexion
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
